import otherSettings from './settings';
import { settings, overrideSettings, removeSettings } from '@alme/ui-web/settings/settings-util';
import settingsToRemove from './remove';

import { initializeCustomSettings, AlightCustomSettingsType } from './alight-custom-settings';

const settingsToOverride = {
    version: process.env.VERSION,
    ...otherSettings,
};

function InitializeSettings(): void {
    initializeCustomSettings();
    overrideSettings(settingsToOverride);
    removeSettings(settingsToRemove);
}

const ClientCustomSettings = settings as AlightCustomSettingsType;

export { InitializeSettings, ClientCustomSettings };



// WEBPACK FOOTER //
// ./settings/init-settings.ts